// SMOOTH SCROLL FOR ANCHOR LINKS
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault(); // Prevent default jump behavior

    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      const header = document.querySelector('.c-header');
      const headerHeight = header ? header.offsetHeight : 0;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 8; // 8px extra spacing
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  });
});